export default __webpack_public_path__ + "static/avatar-mp-kayi-female-0-v4-detail-4850c59b55d0839b7d03b0fda6c5a208.png";